import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const CER = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="CER - CENTRO ESPECIALIZADO DE REABILITAÇÃO" />
                    <CheckContainer>
                        <HeaderVerde texto="Tipo de Habilitação" />
                        <CheckBox texto="Física" grupo="cerhabilitacao" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Visual" grupo="cerhabilitacao" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Auditiva" grupo="cerhabilitacao" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Intelectual" grupo="cerhabilitacao" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Oficina Ortopédica" grupo="cerhabilitacao" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Outras" grupo="cerhabilitacao" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />

                    </CheckContainer>
                    <div style={{ textAlign: "left" }}>

                        <Input label="Carga Horária de Fisioterapia" nome="cercarga" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Atende Documento Instrutivo do CER" nome="cerdoc" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                    <HeaderVerde texto="ESPECIALIDADES DA SAÚDE" />
                    <CheckContainer>
                        <HeaderVerde texto="Tipo de Habilitação" />
                        <CheckBox texto="Fisioterapeuta" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Terapeuta Ocupacional" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fonoaudiólogo" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Psicólogo" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Nutricionista" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Médico" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Enfermeiro" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Outros" grupo="cersaude" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>
                    <Input label="Outras Especialidades da Saúde" nome="cerespecialidade" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="80vw" widthMobile="80vw" marginR="3vw" />
                </Caixa>
            )
        }
        return partes
    }
}

export default CER